import { LocationSource } from '@carvana/merch-geolocation';
import {
  type IncomingMessage,
  ListenerEvent,
  MessageHandler
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import UserContext from '~/context/common/UserContext';
import getGeoLocationApi from '~/services/common/getGeoLocationApi';

type UpdateGeolocationPayload = {
  zip: string;
  city?: string;
  state?: string;
};

function isUpdateGeolocationMessage<ListenerEventType>(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, UpdateGeolocationPayload> {
  return (
    message.event === ListenerEvent.UpdateGeolocation &&
    message.payload.zip != null
  );
}

export default function useUpdateGeolocationHandler<
  ListenerEventType
>(): MessageHandler<ListenerEventType, UpdateGeolocationPayload> {
  const {
    location: { setData }
  } = useContext(UserContext);

  return useMemo(
    () =>
      new MessageHandler(isUpdateGeolocationMessage, message => {
        const geoLocationApi = getGeoLocationApi();

        geoLocationApi
          .setGeoLocation({
            source: LocationSource.Modal,
            zip: message.payload.zip
          })
          .then(location => {
            setData(location);
          });
      }),
    [setData]
  );
}
